import React, { useEffect } from 'react'
import ModalCustom from '../../../components/modal-custom'
import { Controller, useForm } from 'react-hook-form'
import { Button, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../../../components/label-custom'
import CustomAutocomplete from '../../../components/CustomAutocomplete'
import { useDebounce } from '@react-hook/debounce'
import UseEmpsCode from '../../../hooks/use-emps-code'
import UseEmpsUsername from '../../../hooks/use-emps-username'
import UseEmpsName from '../../../hooks/use-emps-name'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import UseEmpsReportby from '../../../hooks/use-emps-reportby'
import PickerRangeCustom from '../../../components/datepicker-between-custom'
import { fnDateEn } from '../../../helper/fnDateEn'
import AutocompleteMulti from '../../../components/AutocompleteMulti'
import UseEmpsTypes from '../../../hooks/use-emps-types'
import UseEmpsTypeDate from '../../../hooks/use-emps-type-date'
import UseEmpsPosition from '../../../hooks/use-emps-position'
import UseEmpsProbations from '../../../hooks/use-emps-probations'
import UseEmpsLavel from '../../../hooks/use-emps-lavel'
import { BsSearch } from 'react-icons/bs'
import UseEmpsStatus from '../../../hooks/use-emps-status'
import { BODY } from '../../../Constants'
import UseTeamsAll from '../../../hooks/use-teams-all'
import DatepickerCustom from '../../../components/datepicker-custom'
import moment from 'moment'

export default function ModalFilterPim({
  roleId,
  open,
  onCancel,
  getEmps,
  isLoading
}) {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm()
  const [keyCode, setKeyCode] = useDebounce('', 1000)
  const empCode = UseEmpsCode(roleId, keyCode)
  const [keyName, setKeyName] = useDebounce('', 1000)
  const [keyUsername, setKeyUsername] = useDebounce('', 1000)
  const [keyReportTo, setKeyReportTo] = useDebounce('', 1000)
  const [keyPosition, setKeyPosition] = useDebounce('', 1000)
  const [keyTeam, setKeyTeam] = useDebounce('', 1000)

  const empUsername = UseEmpsUsername(roleId, keyUsername)
  const empName = UseEmpsName(roleId, keyName)
  const reportTo = UseEmpsReportby(roleId, keyReportTo)
  const empsTypes = UseEmpsTypes()
  const typeDates = UseEmpsTypeDate(roleId)
  const empPosition = UseEmpsPosition(roleId, keyPosition)
  const empProbations = UseEmpsProbations()
  const empsLavel = UseEmpsLavel()
  const empStatus = UseEmpsStatus()
  const bodyQuery = localStorage.getItem(BODY)
  const teams = UseTeamsAll(roleId, keyTeam)

  useEffect(() => {
    const d = JSON.parse(bodyQuery)

    if (['0', '1'].includes(d?.statusId + '')) {
      const empStatusNew = empStatus.find(
        (item) => item.value + '' === d?.statusId + ''
      )
      setValue('statusId', empStatusNew)
    } else {
      setValue('statusId', { value: '', label: 'ทั้งหมด' })
    }
    d?.code && setValue('code', { value: d?.code, label: d?.code })
    d?.username &&
      setValue('username', { value: d?.username, label: d?.username })
    d?.name && setValue('name', { value: d?.name, label: d?.name })
    d?.works && setValue('department', d?.works)

    if (d?.positionId) {
      const typeIdNew = empsTypes.find(
        (item) => item.value + '' === d?.typeId + ''
      )
      d?.typeId && setValue('typeId', typeIdNew)
    }
    d?.position &&
      setValue('position', { value: d?.positionId, label: d?.position })
    d?.team && setValue('team', { value: d?.teamId, label: d?.team })

    d?.dateEnd && d?.dateStart && setValue('date', [d.dateStart, d.dateEnd])

    d?.probation &&
      setValue('probation', { value: d?.probationId, label: d?.probation })
    d?.typeDate &&
      setValue('typeDate', { value: d?.typeDate, label: d?.typeDateLabel })
    d?.username &&
      setValue('username', { value: d?.username, label: d?.username })

    d?.identity && setValue('identity', d?.identity)
    d?.nickname && setValue('nickname', d?.nickname)
    d?.searchs && setValue('search', d?.searchs)

    if (d?.reportTo) {
      const reportToNew = reportTo.find(
        (item) => item.value + '' === d?.reportTo + ''
      )
      d?.reportTo && setValue('reportTo', reportToNew)
    }

    if (d?.reportTo) {
      const typeIdNew = empsTypes.find(
        (item) => item.value + '' === d?.typeId + ''
      )
      d?.typeId && setValue('typeId', typeIdNew)
    }

    if (d?.levelId?.length > 0 && empsLavel.length > 0) {
      const level = d?.levelId.map((l) => {
        let _vel = empsLavel.find((item) => item.value === l)
        return _vel
      })
      setValue('levelId', level)
    }
    if (d?.typeId?.length > 0 && empsTypes.length > 0) {
      const level = d?.typeId.map((t) => {
        let _vel = empsTypes.find((item) => item.value === t)
        return _vel
      })
      setValue('typeId', level)
    }
    d?.dateActive && setValue('dateActive', d?.dateActive)
  }, [bodyQuery, empStatus, empsLavel, empsTypes, reportTo, setValue])

  const onSubmit = (data) => {
    const datas = {
      works: data.department ?? '',
      code: data.code?.value ?? '',
      username: data.username?.value ?? '',
      name: data.name?.value ?? '',
      typeId:
        data.typeId?.length > 0 ? data.typeId.map((item) => item.value) : [],
      type: data.typeId?.label ?? '',
      probationId: data.probation?.value ?? '',
      probation: data.probation?.label ?? '',
      statusId: data.statusId?.value ?? '',
      status: data.statusId?.label ?? '',
      typeDate: data.typeDate?.value,
      typeDateLabel: data.typeDate?.label,
      dateStart: data.date ? data.date[0] : '',
      dateEnd: data.date ? data.date[1] : '',
      positionId: data.position?.value ?? '',
      position: data.position?.label ?? '',
      identity: data.identity && data.identity.replaceAll(' ', ''),
      nickname: data.nickname,
      reportTo: data.reportTo?.value ?? '',
      team: data.team?.label ?? '',
      teamId: data.team?.value ?? '',
      dateActive: data.dateActive ?? '',

      ...(data.levelId && {
        levelId:
          data.levelId?.length > 0 ? data.levelId.map((item) => item.value) : []
      })
    }
    const body = {
      page: 1,
      orgId: roleId,
      size: 20,
      ...datas
    }

    getEmps(body)
  }

  return (
    <ModalCustom width={1300} open={open} onCancel={onCancel}>
      <h4>Filter</h4>
      <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
        <Row style={{ rowGap: '15px' }}>
          <Col xl={3} md={4}>
            <LabelCustom text={'รหัสพนักงาน'} />
            <Controller
              name={'code'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empCode}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyCode(data.label)
                    } else {
                      setKeyCode('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="Username" />
            <Controller
              name={'username'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empUsername}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyUsername(data.label)
                    } else {
                      setKeyUsername('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="ชื่อพนักงาน" />
            <Controller
              name={'name'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empName}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyName(data.label)
                    } else {
                      setKeyName('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text={'ชื่อเล่น'} />
            <Controller
              name={'nickname'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text={'เลขประจำตัวประชาชน/เลขพาสปอร์ต'} />
            <Controller
              name={'identity'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text={'สายงาน/ฝ่าย/แผนก'} />
            <Controller
              name={'department'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text={'ผู้บังคับบัญชา'} />
            <Controller
              name={'reportTo'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={reportTo}
                  value={value}
                  onChange={onChange}
                  onInputChange={(data) => {
                    setKeyReportTo(data)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={3} md={2}>
            <LabelCustom text="ประเภทพนักงาน" />
            <Controller
              name={'typeId'}
              control={control}
              render={({ field: { onChange, value = [] } }) => (
                // <Select
                //   mode="multiple"
                //   allowClear
                //   style={{
                //     width: '100%'
                //   }}
                //   value={typeStId}
                //   onChange={(e) => {
                //     onChange(e)
                //     handleChange(e)
                //   }}
                //   options={empsTypes}
                // />
                <AutocompleteMulti
                  placeholder={``}
                  options={empsTypes}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="สถานะทดลองงาน" />
            <Controller
              name={'probation'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={empProbations}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col xl={3} md={2}>
            <LabelCustom text="ประเภทวันที่" />
            <Controller
              name={'typeDate'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={typeDates}
                  value={value}
                  onChange={(data) => {
                    onChange(data)

                    if (data?.value === 2) {
                      setValue('statusId', {
                        value: '',
                        label: 'ทั้งหมด'
                      })
                    } else {
                      setValue('statusId', {
                        value: '1',
                        label: 'พนักงาน'
                      })
                    }
                  }}
                />
              )}
            />
          </Col>
          <Col xl={4} md={4}>
            <LabelCustom text="วันที่" />
            <Controller
              name={'date'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <PickerRangeCustom
                  value={value}
                  onChange={(date) => {
                    if (date.length > 1) {
                      const st = fnDateEn(date[0]).format('YYYY-MM-DD')
                      const en = fnDateEn(date[1]).format('YYYY-MM-DD')
                      setValue('date', [st, en])
                    } else if (date.length === 0) {
                      setValue('date', ['', ''])
                    }
                  }}
                />
              )}
            />
          </Col>
          <Col xl={2} md={2}>
            <LabelCustom text="สถานะพนักงาน" />
            <Controller
              name={'statusId'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={[{ value: '', label: 'ทั้งหมด' }, ...empStatus]}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col xl={3} md={6}>
            <LabelCustom text="ตำแหน่ง " />
            <Controller
              name={'position'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empPosition}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyPosition(data.value)
                    } else {
                      setKeyPosition('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={6}>
            <LabelCustom text="ทีม " />
            <Controller
              name={'team'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={teams}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyTeam(data.value)
                    } else {
                      setKeyTeam('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={6}>
            <LabelCustom text="Level " />
            <Controller
              name={'levelId'}
              control={control}
              render={({ field: { onChange, value = [] } }) => (
                <AutocompleteMulti
                  placeholder={``}
                  options={empsLavel}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col xl={3} md={6}>
            <LabelCustom text={'วันที่คงสภาพพนักงาน'} />
            <Controller
              name={'dateActive'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <DatepickerCustom
                  value={value}
                  onChange={([date]) => {
                    setValue(
                      'dateActive',
                      date ? moment(date).format('YYYY-MM-DD') : ''
                    )
                  }}
                />
              )}
            />
          </Col>

          <Col xl={12} md={12} className="align-self-end text-end">
            <Button type="submit" disabled={isLoading} className=" px-4">
              <BsSearch /> ค้นหา{isLoading && '...'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
